import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { VisitorListItem } from '../services/get-visitors.service';

interface PermissionsState {
  visitor: VisitorListItem | null;
}

const initialState: PermissionsState = {
  visitor: null,
};

const permissionsSlice = createSlice({
  name: 'users',
  initialState,
  reducers: {
    setVisitor: (state, action: PayloadAction<VisitorListItem>) => {
      state.visitor = action.payload;
    },
    clearVisitor: state => {
      state.visitor = null;
    },
  },
});

export const { setVisitor, clearVisitor } = permissionsSlice.actions;
export default permissionsSlice.reducer;
